var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCirclePurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.25 0h32v32h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3a13 13 0 0 1 8.64 22.714A12.952 12.952 0 0 1 16.251 29a12.955 12.955 0 0 1-8.644-3.287l-.296-.272A13 13 0 0 1 16.249 3zm0 19a8.984 8.984 0 0 0-6.466 2.737l-.09.095.24.177a10.958 10.958 0 0 0 5.892 1.983l.425.008c2.27.003 4.473-.698 6.313-1.99l.24-.178-.088-.095a8.986 8.986 0 0 0-6.1-2.73L16.25 22zm0-17a11 11 0 0 0-8.14 18.401l.092.097.039-.04a10.984 10.984 0 0 1 7.611-3.451L16.25 20a10.984 10.984 0 0 1 8.01 3.458l.036.04.093-.097a11.001 11.001 0 0 0 2.275-10.944l-.132-.367A11 11 0 0 0 16.249 5zm0 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
    fill: "#821BB8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCirclePurple);
export default __webpack_public_path__ + "static/media/user-circle-purple.610a86b0e86f3387abd9775fc9aefa8f.svg";
export { ForwardRef as ReactComponent };